var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardNeedMoreTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 65,
    viewBox: "0 0 56 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 28,
    cy: 37,
    r: 28,
    fill: "#D2EAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.039 28.3871C38.1371 28.3871 40.6487 25.8755 40.6487 22.7774C40.6487 19.6792 38.1371 17.1676 35.039 17.1676C31.9408 17.1676 29.4292 19.6792 29.4292 22.7774C29.4292 25.8755 31.9408 28.3871 35.039 28.3871Z",
    fill: "#FEE2B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5663 43.961C31.6645 43.961 34.1761 41.4494 34.1761 38.3512C34.1761 35.253 31.6645 32.7415 28.5663 32.7415C25.4681 32.7415 22.9565 35.253 22.9565 38.3512C22.9565 41.4494 25.4681 43.961 28.5663 43.961Z",
    fill: "#FEE2B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7318 28.3871C15.83 28.3871 18.3416 25.8755 18.3416 22.7774C18.3416 19.6792 15.83 17.1676 12.7318 17.1676C9.63364 17.1676 7.12207 19.6792 7.12207 22.7774C7.12207 25.8755 9.63364 28.3871 12.7318 28.3871Z",
    fill: "#FEE2B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2195 55.3136H14.9756C10.0267 55.3136 6 51.2869 6 46.338C6 41.389 10.0267 37.3623 14.9756 37.3623H22.8293V39.6063H14.9756C11.2631 39.6063 8.2439 42.6254 8.2439 46.338C8.2439 50.0505 11.2631 53.0697 14.9756 53.0697H17.2195V55.3136ZM43.0244 39.6063H34.0488V37.3623H43.0244C46.7369 37.3623 49.7561 34.3432 49.7561 30.6306C49.7561 26.9181 46.7369 23.8989 43.0244 23.8989H40.7805V21.655H43.0244C47.9733 21.655 52 25.6817 52 30.6306C52 35.5796 47.9733 39.6063 43.0244 39.6063Z",
    fill: "#FDAC42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5613 21.655H18.3418V23.8989H29.5613V21.655Z",
    fill: "#FDAC42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2586 5.82502L16.1567 9.70836V0L31.2586 5.82502Z",
    fill: "#FDAC42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6181 0.000244141H14V18.2931H15.6181V0.000244141Z",
    fill: "#555770"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.24 38.3512C36.24 41.2423 33.8963 43.586 31.0053 43.586C28.1142 43.586 25.7705 41.2423 25.7705 38.3512C25.7705 35.4601 28.1142 33.1165 31.0053 33.1165C33.8963 33.1165 36.24 35.4601 36.24 38.3512Z",
    stroke: "#FDAC42",
    strokeWidth: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1126 22.844C42.1126 25.7351 39.7689 28.0788 36.8778 28.0788C33.9867 28.0788 31.6431 25.7351 31.6431 22.844C31.6431 19.9529 33.9867 17.6093 36.8778 17.6093C39.7689 17.6093 42.1126 19.9529 42.1126 22.844Z",
    stroke: "#FDAC42",
    strokeWidth: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1614 22.844C20.1614 25.7351 17.8177 28.0788 14.9266 28.0788C12.0356 28.0788 9.69189 25.7351 9.69189 22.844C9.69189 19.9529 12.0356 17.6093 14.9266 17.6093C17.8177 17.6093 20.1614 19.9529 20.1614 22.844Z",
    stroke: "#FDAC42",
    strokeWidth: 0.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2514 59.0633C27.3495 59.0633 29.8611 56.5517 29.8611 53.4535C29.8611 50.3553 27.3495 47.8438 24.2514 47.8438C21.1532 47.8438 18.6416 50.3553 18.6416 53.4535C18.6416 56.5517 21.1532 59.0633 24.2514 59.0633Z",
    fill: "#FEE2B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.137 53.332C31.137 56.2231 28.7933 58.5668 25.9022 58.5668C23.0112 58.5668 20.6675 56.2231 20.6675 53.332C20.6675 50.441 23.0112 48.0973 25.9022 48.0973C28.7933 48.0973 31.137 50.441 31.137 53.332Z",
    stroke: "#FDAC42",
    strokeWidth: 0.75
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardNeedMoreTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CardNeedMoreTime.b993f699021f188e34f389ef0ea4bcbe.svg";